export default "__VITE_ASSET__b0763cf2__"